import {
  GET_REGION,
  GET_REGION_FAIL,
  GET_REGION_SUCCESS,
  GET_REGIONS,
  GET_REGIONS_FAIL,
  GET_REGIONS_SUCCESS,
  ADD_NEW_REGION,
  ADD_REGION_SUCCESS,
  ADD_REGION_FAIL,
  UPDATE_REGION,
  UPDATE_REGION_SUCCESS,
  UPDATE_REGION_FAIL,
  DELETE_REGION,
  DELETE_REGION_SUCCESS,
  DELETE_REGION_FAIL,
  SET_STATE_REGION,
  UPDATE_REGION_STATUS
} from "./actionTypes"

export const setState = ( loading ) => ({
  type: SET_STATE_REGION,
  payload: loading,
})

export const getRegions = ( params ) => ({
  type: GET_REGIONS,
  payload: { params },
})

export const getRegionsSuccess = (regions, totalPages, currentPage) => ({
  type: GET_REGIONS_SUCCESS,
  payload: { regions:regions, total:totalPages, currentPage:currentPage}
})

export const getRegionsFail = error => ({
  type: GET_REGIONS_FAIL,
  payload: error,
})

export const addNewRegion = region => ({
  type: ADD_NEW_REGION,
  payload: region,
})

export const addRegionSuccess = region => ({
  type: ADD_REGION_SUCCESS,
  payload: region,
})  

export const addRegionFail = error => ({
  type: ADD_REGION_FAIL,
  payload: error,
})

export const updateRegion = region => ({
  type: UPDATE_REGION,
  payload: region,
})

export const updateRegionStatus = region => ({
  type: UPDATE_REGION_STATUS,
  payload: region,
})

export const updateRegionSuccess = region => ({
  type: UPDATE_REGION_SUCCESS,
  payload: region,
})

export const updateRegionFail = error => ({
  type: UPDATE_REGION_FAIL,
  payload: error,
})

export const deleteRegion = region => ({
  type: DELETE_REGION,
  payload: region,
})

export const deleteRegionSuccess = id => ({
  type: DELETE_REGION_SUCCESS,
  id,
})

export const deleteRegionFail = error => ({
  type: DELETE_REGION_FAIL,
  payload: error,
})

export const getRegion = () => ({
  type: GET_REGION,
})

export const getRegionSuccess = region => ({
  type: GET_REGION_SUCCESS,
  payload: region,
})

export const getRegionFail = error => ({
  type: GET_REGION_FAIL,
  payload: error,
})
